import { MultiOrganisationController } from './multi-organisation.controller';

export const MultiOrganisationComponent = {
  bindings: {
    organisation: '<',
  },
  templateUrl: 'multi-organisation/multi-organisation.html',
  controller: MultiOrganisationController,
};
